define('views/filefinder/Podio.Views.FileFinderUpload',['require','underscore','jquery','lib/backbone/Backbone.PodioView','jst!filefinder/_tab_upload','lib/fileuploader/multi'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');

  var jstTabUpload = require('jst!filefinder/_tab_upload');

  return PodioView.extend({

    initialize: function(options) {
      _.bindAll(this, 'render', 'onFileListChanged');

      this.elm = $(this.el);
      this.hasOptions = false;
      this.eventBridge = options.eventBridge;
      this.providerName = options.providerName;
      this.onlyAllowImages = options.onlyAllowImages;
      this.onlyAllowVideos = options.onlyAllowVideos;
      this.allowedMimeTypes = options.allowedMimeTypes;
      this.multipleFiles = options.multipleFiles;
      this.fileType = 'upload';
    },

    render: function() {
      var self = this;

      this.elmTab = $(this.getTemplate(jstTabUpload, {
        item: this.model
      }));

      this.elm.append(this.elmTab);

      var fileUploaderMulti = require('lib/fileuploader/multi'); // Circular reference, as it's filefinder is also used from the uploader.

      this.uploaderInstance = fileUploaderMulti.render(this.elmTab, {
        skin : 'multi-file filefinder',
        elmHiddenInput : this.elmTab.find('.files-hidden-input'),
        showDialogOnInit : false,
        onlyAllowImages : this.onlyAllowImages,
        onlyAllowVideos : this.onlyAllowVideos,
        allowedMimeTypes : this.allowedMimeTypes,
        multipleFiles: this.multipleFiles
      });

      this.uploaderInstance.signals.onFileAdded.add(function() {
        self.hideDragTip();
      });

      this.uploaderInstance.signals.onFileRemoved.add(function(filesCount) {
        self.onFileListChanged();

        if (!filesCount) {
          self.showDragTip();
        }
      });

      this.uploaderInstance.signals.onFileUploaded.add(function() {
        self.onFileListChanged();

        if ( !self.multipleFiles ) {
          self.eventBridge.trigger('finished');
        }

      });

      return this;
    },

    onFileListChanged: function() {
      this.eventBridge.trigger('fileListChanged', this.providerName);
    },

    hideDragTip : function() {
      this.elmTab.find('.drag-tip-wrapper').hide();
    },

    showDragTip : function() {
      this.elmTab.find('.drag-tip-wrapper').show();
    },

    hide : function() {
      this.elmTab.addClass('hidden');
    },

    show : function() {
      this.elmTab.removeClass('hidden');
      this.elmTab.removeClass('minimized');
    },

    dispose: function() {
      this.remove();
    },

    showLoader : function() {
      this.elm.addClass('loading-overlay-small');
    },

    hideLoader : function() {
      this.elm.removeClass('loading-overlay-small');
    },

    getFiles : function() {
      var dfd = new $.Deferred();

      var data = {
        'provider' : 'upload',
        'type'     : 'file',
        'ids'      : _.compact(this.elmTab.find('input[type=hidden]').val().split(','))
      };

      dfd.resolve(data);

      return dfd;
    }
  });
});

